<template>
    <div @click="clickBlock" class="MuiBox-root css-16uq0dq radio-checkbox" :class="value == value_v ? 'radio-checkbox_checked' : '' ">
        <div class="MuiGrid-root MuiGrid-container css-gr1e5v" :class="disabled ? 'radio-checkbox-disabled' : ''">
            <div class="MuiGrid-root MuiGrid-container MuiGrid-item css-1uuox1t">
                <input :disabled="disabled ? true : false" :checked="value == value_v" @change="changeField($event.target.checked)" :type="type" class="css-1yo4zo5" :value="value_v" :name="name">
                <div class="MuiGrid-root MuiGrid-item css-4hz01p">
                    <div class="MuiTypography-root MuiTypography-body1 MuiBox-root css-5on0ae">
                        <p class="MuiTypography-root MuiTypography-body1 css-fpw8s0" :class="disabled ? 'disabled' : ''">
                            {{ text }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
	export default {
	    props: ['text', 'value', 'type', 'value_v', 'name', 'disabled'],
        methods: {
            changeField (val) {
                if (val) {
                    this.$emit('change_c', this.value_v)
                }
            },
            clickBlock () {
                if (this.disabled) {
                    return null
                }

                if (this.type == 'radio') {
                    this.$emit('change_c', this.value_v)
                }
            },
        }
	}
</script>
<style scoped>
.disabled {
    opacity: 0.7;
}
</style>
